import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import RoutingRules from "./RoutingRules";
import AssignedCoders from "./AssignedCoders";
import { useSelector } from "react-redux";
import savechanges_icon from "../../../common/assets/images/savechanges.png";
import { assignedByList, createQueue, fetchQueueDetails } from "../../../store/queueSlice";
import { useDispatch } from "react-redux";
import LdsRoller from "../../../utils/LdsRoller";
import { toast } from "react-toastify";

const QueueForm = ({
  showRuleAddSection,
  handleRuleAdder,
  formData,
  setFormData,
  disableInput,
  selectedRules,
  setSelectedRules
}) => {
  const queueDetailsData = useSelector((state) => state.queue.queueDetailsData);
  const dispatch = useDispatch();
  const loadingDetails = useSelector(
    (state) => state.queue.loadingQueueDetails
  );
  const [selectedCoder, setSelectedCoder] = useState([]);
  // Populate formData when Redux data is available
  useEffect(() => {
    if (queueDetailsData && Object.keys(queueDetailsData).length > 0) {
      setFormData(queueDetailsData);
    }
  }, [queueDetailsData]);
  // console.log(formData, loadingDetails, "seeformdata");

  const handleFormSubmit = () => {
     if (!formData.priority) {
      toast.error("Please select a priority");
      console.log("Submission blocked: Priority is required");
      return;
    }
    const payload = {
    
        queue_name: formData?.queue_name || "",
        description: formData?.description || "",
        priority: formData?.priority || "",
        is_active: formData?.is_active || false,
        routing_rules: (formData?.routing_rules || []).map((rule) => ({
          rule_id: rule.rule_id,
          rule_condition_id: rule.rule_condition_id,
          operator: rule.operator,
          value_to_compare: rule?.value_to_compare.toUpperCase(),
        })),
        // assigned_user_id: [selectedCoder?.user_id],
       assigned_user_id: selectedCoder.map(coder => coder.user_id) || [],
    };
  
    dispatch(createQueue(payload))
      .unwrap()
      .then((res) => {
        toast.success(
          formData?.queue_id
            ? "Queue saved successfully!"
            : "Queue created successfully!"
        );
  
        // Dispatch fetchQueueDetails only after createQueue success
        const queueIdToFetch = res?.data?.queue_id || formData?.queue_id;
        if (queueIdToFetch) {
          dispatch(fetchQueueDetails(queueIdToFetch));
        }
      })
      .catch((error) => {
        toast.error("Something went wrong while saving the queue.");
        console.error(error);
      });
  };
  

  // console.log(formData, "ii");
useEffect(() => {
  return () => {
    toast.dismiss();
  };
}, []);
  return (
    <>
      {loadingDetails ? (
        <div className="text-center mt-5">
          <LdsRoller />
        </div>
      ) : (
        <form className="queue-creation-form">
          <div className="form-wrapper">
            <div className="d-flex flex-row justify-content-between gap-3 queue-id-name-form">
              <div className="d-flex flex-column w-100 gap-1">
                <label>Queue ID</label>
                 <input
                  type="text"
                  placeholder="Auto generated"
                  value={formData?.queue_id || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, queue_id: e.target.value })
                  }
                  disabled
                />
              </div>
              <div className="d-flex flex-column w-100 gap-1">
                <label>Queue Name</label>
                <input
                  type="text"
                  value={formData?.queue_name || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, queue_name: e.target.value })
                  }
                  disabled={disableInput}
                />
              </div>
            </div>
            <div className="d-flex flex-column w-100 gap-1">
              <label>Description</label>
              <textarea
                type="text"
                value={formData?.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </div>
            <div className="d-flex flex-row justify-content-between gap-3">
              <div className="d-flex flex-column w-100 gap-1">
                <label>Priority</label>
                <Dropdown className="form-dropdown status">
                  <Dropdown.Toggle >
                    {formData?.priority || "Select Priority"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["Urgent", "High", "Low", "Overdue", "Nil assigned"].map(
                      (priorityOption, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              priority: priorityOption,
                            }))
                          }
                        >
                          {priorityOption}
                        </Dropdown.Item>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="d-flex flex-column w-100 gap-1">
                <label>Status</label>
                <Dropdown className="form-dropdown status">
                  <Dropdown.Toggle>
                    {formData?.is_active ? "Active" : "InActive"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        setFormData((prev) => ({ ...prev, is_active: true }))
                      }
                    >
                      Active
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setFormData((prev) => ({ ...prev, is_active: false }))
                      }
                    >
                      InActive
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="d-flex flex-column w-100 gap-1">
              <label>Routing Rules</label>
              <RoutingRules
                showRuleAddSection={showRuleAddSection}
                handleRuleAdder={handleRuleAdder}
                routing_rules={formData?.routing_rules}
                formData={formData}
                setFormData={setFormData}
                selectedRules={selectedRules}
                setSelectedRules={setSelectedRules}
              />
            </div>
            <div className="d-flex flex-column w-100 gap-1">
              <label>Assigned Coders</label>
              <AssignedCoders
                assignedCoders={formData?.assigned_coders}
                selectedCoder={selectedCoder}
                setSelectedCoder={setSelectedCoder}
                formData={formData}
                setFormData={setFormData}
              />
            </div>
          </div>
          <div className="form-btn-wrapper">
            <button
              onClick={(e) => {
                e.preventDefault();
                setFormData({
                  queue_id: "",
                  queue_name: "",
                  description: "",
                  priority: "",
                  is_active: true,
                  routing_rules: [],
                  assignedCoders: [],
                });
              }}
            >
              Cancel
            </button>
            <button type="button" onClick={handleFormSubmit}>
              <img
                src={savechanges_icon}
                style={{ height: "14px" }}
                alt="save"
              />
              {formData?.queue_id ? "Save Changes" : "Create Queue"}
            </button>
          </div>
        </form>
      )}
    </>
  );
};

export default QueueForm;
